// import React, { useEffect, useState } from 'react';
// import '../assets/js/login.js';
// import '../assets/css/custom.css';

// import API_BASE_URL from "../../helper";
// function AdminLogin() {


//   return (
//   <div>

//     <section>
//         <div className='container-fluid' style={{height:"100vh", background:"#9053c7"}}>
//             <div className='h-100 d-flex justify-content-center align-items-center'>
//                 <div>
//                     <h2 className='text-center text-white text-uppercase'>Admin Login</h2>
//                     <form id='adminLogin' className='bg-white p-lg-5 p-2'>
//                         <div class="row g-3 justify-content-center">

//                             <div class="col-md-12 mb-3">
//                                 <label class="form-label text-dark"><b>Email</b></label>
//                                 <input type="text" id="email"  name='email' placeholder='enter email'  class="form-control" />
//                             </div>

//                             <div class="col-md-12 mb-3">
//                                 <label class="form-label text-dark"><b>Password</b></label>
//                                 <input type="password" id="password" name='password' placeholder='enter password'  class="form-control" />
//                             </div>

//                             <div class="col-md-12 text-center mb-3">
//                                 <button className='btn btn-primary px-4 text-uppercase'>
//                                     Login
//                                 </button>
//                             </div>
//                         </div>
//                     </form>
//                 </div>
//             </div>
//         </div>
//     </section>

//     {/* ✅ Universal Success Modal */}
//         <div class="modal fade" id="successModal" tabindex="-1" aria-labelledby="successModalLabel" aria-hidden="true">
//             <div class="modal-dialog modal-dialog-centered">
//                 <div class="modal-content border-0 shadow-lg">

//                     <div class="modal-header bg-success text-white">
//                     <h5 class="modal-title fw-bold" id="successModalLabel">
//                         <i class="bi bi-check-circle-fill me-2"></i> Success
//                     </h5>
//                     <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
//                     </div>

//                     <div class="modal-body text-center py-4 d-flex justify-content-center align-items-center flex-column">
//                     <svg xmlns="http://www.w3.org/2000/svg" class="text-success mb-3" width="60" height="60" fill="currentColor" viewBox="0 0 16 16">
//                         <path d="M16 8A8 8 0 11.001 8a8 8 0 0115.999 0zM6.97 11.03a.75.75 0 001.06 0l4.992-4.992a.75.75 0 10-1.06-1.06L7.5 9.939 4.53 6.97a.75.75 0 10-1.06 1.06l3.5 3.5z"/>
//                     </svg>
//                     <h5 id="successMessage" class="fw-semibold text-dark">Action completed successfully!</h5>
//                     </div>

//                     <div class="modal-footer border-0 justify-content-center">
//                         <button type="button" class="btn btn-success px-4" data-bs-dismiss="modal">OK</button>
//                     </div>

//                 </div>
//             </div>
//         </div>

//   </div>
//   )
// }

// export default AdminLogin;

import React, { useState } from "react";
import axios from "axios";
import API_BASE_URL from "../../helper";

function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  
  const loginAdmin = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(`${API_BASE_URL}/api/admin/login`, null, {
        params: { email, password }
      });

      if (response.data === "SUCCESS") {
        localStorage.setItem("adminLoggedIn", "true");
        window.location.href = "/admin/dashboard";
      }
    } catch (error) {
      alert("Invalid Email or Password!");
    }
  };

  return (
    <div>
        <section>
        <div className="container-fluid" style={{ height: "100vh", background: "#9053c7" }}>
            <div className="h-100 d-flex justify-content-center align-items-center">
            <form onSubmit={loginAdmin} className="bg-white p-lg-5 p-2">
                <h2 className="text-center text-dark text-uppercase">Admin Login</h2>

                <div className="mb-3">
                <label><b>Email</b></label>
                <input type="text" className="form-control" 
                        value={email} onChange={(e) => setEmail(e.target.value)} />
                </div>

                <div className="mb-3">
                <label><b>Password</b></label>
                <input type="password" className="form-control"  
                        value={password} onChange={(e) => setPassword(e.target.value)} />
                </div>

                <div className="text-center">
                <button className="btn btn-primary px-4">Login</button>
                </div>
            </form>
            </div>
        </div>
        </section>
        {/* ✅ Universal Success Modal */}
        <div class="modal fade" id="successModal" tabindex="-1" aria-labelledby="successModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content border-0 shadow-lg">

                    <div class="modal-header bg-success text-white">
                    <h5 class="modal-title fw-bold" id="successModalLabel">
                        <i class="bi bi-check-circle-fill me-2"></i> Success
                    </h5>
                    <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
                    </div>

                    <div class="modal-body text-center py-4 d-flex justify-content-center align-items-center flex-column">
                    <svg xmlns="http://www.w3.org/2000/svg" class="text-success mb-3" width="60" height="60" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M16 8A8 8 0 11.001 8a8 8 0 0115.999 0zM6.97 11.03a.75.75 0 001.06 0l4.992-4.992a.75.75 0 10-1.06-1.06L7.5 9.939 4.53 6.97a.75.75 0 10-1.06 1.06l3.5 3.5z"/>
                    </svg>
                    <h5 id="successMessage" class="fw-semibold text-dark">Action completed successfully!</h5>
                    </div>

                    <div class="modal-footer border-0 justify-content-center">
                        <button type="button" class="btn btn-success px-4" data-bs-dismiss="modal">OK</button>
                    </div>

                </div>
            </div>
        </div>

    </div>
  );
}

export default AdminLogin;
